import { PIPELINE_TOOL_NAMES } from '@kw/quokka-ui';

export const getReviewActionOptions = (hasPermission: boolean, setIsOpenReviewModal: (isOpen: boolean) => void) =>
  hasPermission
    ? [
        {
          label: 'Review Rule',
          value: 'review_rule',
          onClick: () => setIsOpenReviewModal(true),
        },
      ]
    : [];

export const getCategoryFromRuleId = ruleId => {
  const parts = ruleId.split('/');
  if (parts[0] === 'profile' || parts[0] === 'audit') {
    return parts[1] || parts[0];
  }
  return parts[0];
};

export const isBehavioral = ruleSummary =>
  (ruleSummary.rule?.tool === PIPELINE_TOOL_NAMES.pattern ||
    ruleSummary.rule?.tool === `${PIPELINE_TOOL_NAMES.pattern}-ios` ||
    ruleSummary.rule?.tool === PIPELINE_TOOL_NAMES.permission) &&
  ruleSummary.rule?.id?.startsWith('profile');
